<div class="export-to-file">
  <div class="content-container">
    <h5 class="title">{{ 'columns_to_export' | t }}</h5>

    <div class="content">
      <div
        *ngIf="(availableColumnsForExport$ | async) as availableColumnsForExport; else loader"
        class="checkbox-container"
        [ngClass]="!availableColumnsForExport ? 'loading' : ''">
        <ng-container>
          <div *ngFor="let column of availableColumnsForExport" class="single-checkbox">
            <app-global-checkbox
              [checked]="column.checked"
              [required]="false"
              [text]="column.name"
              [uncheckedGray]="true"
              (emitChange)="checkboxHandler(column, $event)">
            </app-global-checkbox>
          </div>
        </ng-container>
      </div>
      <ng-template #loader><app-loader></app-loader></ng-template>
    </div>
  </div>
  <div class="footer">
    <div class="footer-container">
      <div class="toggle-switch-wrapper">
        <app-toggle-switch
          [nameTranslationKey]="'save_as_report'"
          (emitChange)="handleSwitch($event)"
          [settingValue]="saveAsReport"
          [fontSize]="13"
          [tooltipText]="'save_as_report_tooltip'">
        </app-toggle-switch>
      </div>
      <div class="right-buttons-container">
        <ng-container *ngIf="selectOptions.length > 0 && !loading">
          <div class="other-content-container">
            <app-select-container [data]="selectOptions" [submitted]="false" [type]="'buttonSelect'" (emitValue)="getSelectedValue($event)">
            </app-select-container>
          </div>
          <div class="export-button-wrapper">
            <app-primary-button
              (click)="exportReport()"
              [disabled]="!checkedValues.length"
              [buttonText]="'export'"
              [background]="'orange'"></app-primary-button>
          </div>
        </ng-container>
        <ng-container *ngIf="loading"><app-loader-for-list></app-loader-for-list></ng-container>
      </div>
    </div>
  </div>
</div>
